import { Dispatch, SetStateAction, useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
import RoundedIcon from 'components/RoundedIcon'
import LightBulb from 'assets/images/emojis/light-bulb.png'
import Calendar from 'assets/images/emojis/calendar.png'
import Darts from 'assets/images/emojis/darts.png'
import ModalContainer from 'components/ModalContainer'
import PrimaryButton from 'components/primaryButton'

interface Item {
  icon: string
  text: string
  id: number
}

const RejectedLineModal = ({
  isOpen,
  setIsOpen,
  isLoan = false
}: {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  isLoan?: boolean
}) => {
  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_por_que_no_tengo_linea' })
  }, [])

  const INFO: Item[] = [
    {
      id: 1,
      icon: LightBulb,
      text: 'La falta de oferta disponible, puede deberse a que tu perfil crediticio no cumple con los requisitos necesarios para poder acceder a un crédito.'
    },
    {
      id: 2,
      icon: Calendar,
      text: `Podés generar una evaluación luego de ${
        isLoan ? '24 horas' : '15 días'
      }.`
    },
    {
      id: 4,
      icon: Darts,
      text: 'Más te conocemos, más podemos prestarte. Por eso es importante que ¡mantengas tus cuotas al día!'
    }
  ]

  return (
    <ModalContainer isShown={isOpen} setModalFunction={setIsOpen} noCloseButton>
      <div className='text-center text-black'>
        <h2 className='font-bold leading-5 mb-6'>
          ¿Por qué no tengo línea de <br /> crédito?
        </h2>
        {INFO.map((i) => (
          <ListItem key={i.id} text={i.text} img={i.icon} />
        ))}
      </div>
      <PrimaryButton
        className='mt-16'
        buttonText='¡Entendido!'
        primaryButtonFunction={() => setIsOpen(false)}
      />
    </ModalContainer>
  )
}

export default RejectedLineModal

const ListItem = ({ text, img }: { text: string; img?: string }) => (
  <div className='flex gap-2 text-left leading-[14px] mb-4 items-center'>
    <RoundedIcon
      className='h-6 w-6'
      icon={<img className='shrink-0 w-3 h-auto' src={img} alt='' />}
    />
    <p className='font-medium text-2xs'>{text}</p>
  </div>
)
